module.exports = __webpack_public_path__ + "img/IN.093a70c9.svg";